
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NavBar, MenuBar } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar
  }
})
export default class TaskTransformExpressionCard extends Vue {
  @Prop({ required: true })readonly obj: any

  data () {
    return {
      isLoading: false,
      taskId: null,
      remainTime: '',
      disabled: true,
      taskData: null,
      score: null,
      scoreReason: null,
      description: '',
      words: [],
      content: '',
      sentence: '',
      sentenceChunks: [],
      highlightedText: ''
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.prepareTaskData()
    // this.mockTaskData()
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  async prepareTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      if (resp.data) {
        this.taskData = JSON.parse(resp.data)
        this.description = this.taskData.description
        this.sentence = this.taskData.fullSentence
        this.highlightedText = this.taskData.highlighted
        this.content = this.taskData.content
        if (!this.sentence.includes(this.highlightedText)) {
          this.highlightedText = ''
        } else {
          this.sentenceChunks = this.sentence.split(this.highlightedText)
        }
      }
      this.description = resp.description
      this.score = resp.score
      this.scoreReason = resp.scoreReason
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.description = null
      this.sentence = null
      this.highlightedText = null
      this.content = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async mockTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      this.description = 'Transform the highlighted part of text into a phrasal verb.'
      this.disabled = false
      this.sentence = 'you won`t be able to change it back'
      this.highlightedText = 'it back.'
      if (!this.sentence.includes(this.highlightedText)) {
        this.highlightedText = ''
      } else {
        this.sentenceChunks = this.sentence.split(this.highlightedText)
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var data = {
      content: this.content
    }
    try {
      const resp = await FetchWrapper.post(
        `${process.env.VUE_APP_SERVERURL}/updateActionPartSentenceTaskData`,
        { data: data, id: Number(this.taskId), completed }
      )
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = `/home/task/${this.taskId}`
          }
        },
        canCancel: false
      })
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not save task data. ${e}`,
        canCancel: false
      })
    }
  }
}
